import React from "react";
import styled from "styled-components";
import { Button, Spinner } from "@blueprintjs/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";

interface IRunButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void>;
  isRunning: boolean;
}

const CodeRunButton = styled(Button)`
  min-height: 0;
  height: 24px;
  width: 56px;
  position: absolute;
  right: 4px;
  top: 3px;
  color: var(--global-off-white) !important;
  font-size: var(--global-font-size-xs);
  padding: 0 8px;
  background: var(--button-green) !important;
  border-radius: 4px;
  border: 1px solid #0f1446;
  :hover {
    background: var(--button-green-hover) !important;
  }
  :active {
    background: var(--button-green-active) !important;
  }
`;

const RunButton: React.FC<IRunButtonProps> = ({ onClick, isRunning }) => {
  return (
    <CodeRunButton onClick={onClick}>
      {isRunning ? (
        <Spinner intent="primary" size={16} />
      ) : (
        <>
          <FontAwesomeIcon icon={faPlay} color={"var(--global-light-gray)"} />{" "}
          Run
        </>
      )}
    </CodeRunButton>
  );
};

export default RunButton;
